import React from "react";
import ReactPlayer from "react-player";
import Map from "./Map";
import "./template.css";

const TwoColumn = ({ columnsData }) => {
  return (
    <div className={"twoColumn " + columnsData.class}>
      <div className={"columns"}>
        {columnsData.columns.length > 0 &&
          columnsData.columns.map((col, idx) => (
            <Column key={"column" + idx} column={col} />
          ))}
      </div>
    </div>
  );
};

const Column = ({ column }) => {
  return (
    <div className={"column " + column.class || ""}>
      {column.title && column.title.text && (
        <h1
          className={column.title.class ? column.title.class : "medium-title"}
        >
          {column.title.text}
        </h1>
      )}
      {column.type === "vid" ? (
        column.src ? (
          <ReactPlayer width={"80%"} url={column.src} />
        ) : (
          <div className="coming-soon-vid black">
            <h1 className={"white-text small-title"}>
              Video Coming September 16
            </h1>
          </div>
        )
      ) : null}
      {column.type === "map" && <Map />}
      {column.type === "img" && (
        <img alt={column.alt} src={process.env.PUBLIC_URL + column.src} />
      )}
      {column.type === "text" &&
        column.rows.map((row, idx) => (
          <div key={row.title + idx} className={"column-row"}>
            {row.title && row.title.text && (
              <h1 className={row.title.class || ""}>{row.title.text}</h1>
            )}
            {row.paragraph && !row.paragraph.text && (
              <p className={"extra-sm-text pre-wrap"}>{row.paragraph}</p>
            )}
            {row.paragraph && row.paragraph.text && (
              <p className={row.paragraph.class}>{row.paragraph.text}</p>
            )}
            {row.link && (
              <a
                className={"Center-link " + row.link.class || ""}
                href={row.link.url}
              >
                {row.link.text}
              </a>
            )}
          </div>
        ))}
    </div>
  );
};

export default TwoColumn;
